import { Container, Text } from '@cottonray/ui-web'
import { BRAND, SERVICES } from './content'
import { ServiceCard } from './Home'

/**
 * 앱 목록 페이지 — `/services` (2026-08-10 사용자 요청).
 * 앱들의 설정 화면 "더 많은 앱"이 여기로 연결된다. 홈의 §서비스 섹션과 같은
 * 카드·레지스트리를 쓰므로 서비스가 늘면 `content.ts` 한 곳만 고치면 된다.
 */
export function ServicesPage() {
  return (
    <section className="band band--surface" id="services">
      <Container>
        <div className="section__head">
          <Text variant="title">{BRAND} apps</Text>
          <Text tone="muted">Everything we run today, plus what is being readied for release.</Text>
        </div>
        <div className="svc-grid">
          {SERVICES.map((service) => (
            <ServiceCard key={service.slug} service={service} />
          ))}
        </div>
      </Container>
    </section>
  )
}
